module.exports = __webpack_public_path__ + "static/media/400043_02.e9a20096.png";